import React from 'react';
import 'antd/dist/antd.css';

import { Layout } from 'antd';
import { Form, Input, Row, Col, Button, Card } from 'antd';

const { Header, Content } = Layout;

const FormItem = Form.Item;

var jwt = require('jsonwebtoken');
var request = require('request');

class DiabetesForm extends React.Component {
  state = {
    result: -1,
    loading: 0
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {

        this.setState({loading: 1});
        console.log('Received values of form: ', values);
        let predict_input = {"instances": [values]};

        let tracer = function (key, value){
          if (typeof value === "string") {
            var parsed = parseInt(value,10);
            if (isNaN(parsed)) { 
              return value
            }
            return parsed
          }
          return value;
        };
        var json_oupt  = JSON.stringify(predict_input, tracer);

        // Private key from the service account JSON file
        var cert = "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC9DrF9lCAc2gYN\ne/Ln4OCIvnhkTfePyl1SXwcwOAgeb5GK+lyFVKce4eOaWps39r8oMeRW7M8BUIuk\n++gBM/CyP8ZRkv5Zdzt+UUsHtqkdD6Xixhca6RHjuPppMZMTmOZpcwQJ4BDR8vru\nrCeFkqU//pT9lZxqqQDnuKSC/ZTCzeoD6LVvAh58Q3a/orOEP7dlkQtHUtFl+EhO\nX/V1qPagVeXkJbNyWnoU1BGlgulTHpPaWzN0yjBa35kQFvNGu7ABd5TLfbdwZRra\nO7Lep7NuEti5XbrCv2vMFbtfLWc0w7N2B0gCKInK/7kBT2SIfVj1TN3QS4G+IN9Q\nt78pQFBrAgMBAAECggEACxRPW9f7FyBtIQvV17easP4ojrLwV8w43S5AfOzrsjeW\nRJoYzfTWDmiX2WCHSXz7sDQBo652ZdH957SeNg6Ag+cE4kbxAkvggANCQw4gqa6p\nvrkeetnpzc9LWDAq5F0eM6klNXGcyruomlAbHign6FuCXmdkJplc5OIx5z32d9ar\nXtgCML0FmNMtIm4ApgDn/jzjixLh1aPGGNDK1ifyY+heqOMJqdBF8hmnHiYZMU6K\nBsEEd7irQrNuWHU4Hn5BEpMzv7BybgbHrrA3x2fIW9VW0awuEYjZuDSmx8FdTm8P\nYvdVBHanatbK/Ff/Ff69tBHjE6caEPklWSs79WzSIQKBgQD9GELvCt1WN8DVFNUk\nYdUz9zC/JKBdK1EUdACh1AU6uS3zDqMmg7S2k2Q9L0Cako5F9bAai+29oB6MONF/\nhxMlPBfz8MErfLfKU6yeWkNC/HKb+6MWU2JS3X5UbKdDQV8QzXFpKnKndVF8QMeZ\n7+2mtRn9cqCyUZbwNe9ejnqUGQKBgQC/OkDKS9hIyfJZINcKiOq2regFko93WW3w\n77tKGmkspgzN6YbS/yNE4WcKBXyE6nDjNA04lpPRSda1wJfYBGCKATYltI1kMaFK\npqYcldc8Ktu9L0mGDy+OFfAIOb8U/TBvJ5UG+4xjXkmOLFt7RuXsdAoNMFRxqFB0\ntHNW1Di5IwKBgQCMD90axHxwtjH0ua6qj6mZNHa5kN9eMBaSpw+ift7V/Jy9IaCQ\nM9rSHwceBQRPhkNN3AU067MJeY7uMpNda7bgqDzpNpbwJfjf8yZYC8OlUmdqgvth\n44tKKGE8/1QhGBAwEEFu3ZrNqVMK3B6ZxflShG55n/HmPNi23mI1hcu4IQKBgEEf\nppb+U28ej1E5NOLalAyYly7mpcNAioeGLSNkcTMKbcvmXssWpr07girQiYJ+kOlf\nfa0q4rZgziVhrJSdkP8OwJEAtzJLEKHqtSGBCibsdZ8tLn3gSBK8d91lRSTxwP/p\n2//fxQTGRIiNpK4MDBuFvTKWpft7FcNY/PqyFYs/AoGBALjnHoI9Zez7eEU6lrzk\nVOGvJDbXxh27UJh9Fwr/mW7XQ3qXyMjpNoLDDdO4CJ/35jdx3Lz4+UB/2TQHn7Mr\n6dchB013wo3WvdMsw312tGpBzVluCYwMckYl2l1xi5XSIHSSnAYrkm6SYFyOPejl\nLYJOCMpdSpCNxRvVFdWdxGv6\n-----END PRIVATE KEY-----";
        var data = {
          'iss': 'cloudmlpredicapi@ml-demo-209802.iam.gserviceaccount.com',
          'scope':'https://www.googleapis.com/auth/cloud-platform',
          'aud': 'https://www.googleapis.com/oauth2/v4/token',
          'iat': Math.round((new Date()).getTime() / 1000),
          'exp': Math.round((new Date()).getTime() / 1000) + 3600
        };
        var token = jwt.sign(data, cert, { algorithm: 'RS256'});
        let oauth_token_get = "https://www.googleapis.com/oauth2/v4/token";
        let req_body = "grant_type=urn%3Aietf%3Aparams%3Aoauth%3Agrant-type%3Ajwt-bearer&assertion="+token+"";
        let self = this;
        request.post(
          {
            headers: {'content-type' : 'application/x-www-form-urlencoded'},
            url: oauth_token_get,
            body: req_body
          },function(err,response,body) {
            if (response.statusCode === 200) {
              let json_bdy = JSON.parse(body);
              let access_token = json_bdy.access_token;
              let predict_uri = "https://ml.googleapis.com/v1/projects/ml-demo-209802/models/diabetes_prediction/versions/v2:predict";
              request.post(
                {
                  headers: {'Content-type' : 'application/json','Authorization' : 'Bearer '+access_token}, 
                  url: predict_uri,
                  body: json_oupt
                }, function(error,res,bdy) {
                  if (response.statusCode === 200) {
                    var final_prediction = JSON.parse(bdy);
                    self.setState({'result': final_prediction['predictions'][0]['classes'], loading: 0}, self.forceUpdate);
                  }
                }
              );
            }
          }
        );
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let cardContent;
    if(this.state.result === "1") {
      cardContent = 
        <div>
          <b>Sorry!</b>
          <p>You are more likely to get diabetes.</p>
        </div>;
    }
    else if (this.state.result === "0"){
      cardContent = 
        <div>
          <b>Great!</b>
          <p>You are healthy and away from getting diabetes.</p>
        </div>;
    }
    else {
      cardContent = 
        <div>
          <p>Click predict to do real time prediction.</p>
        </div>;
    }
    console.log(this.state);

    return (
      <Layout>
        <Header>
          <Row>
          <Col span={21}>
            <h1 style={{color:"#fff"}}>Realtime Diabetes Prediction</h1>
          </Col>
          <Col span={3}>
            <img src="/pluto7-white-logo.png" alt="Pluto7" width="90%"/>
          </Col>
          </Row>
        </Header>
        <Content>
          <br/>
          <Row align="middle" type="flex">
            <br/>
            <Col span={12}>
              <Form onSubmit={this.handleSubmit}>
                <FormItem
                  {...formItemLayout}
                  label="Pregnancies"
                >
                  {getFieldDecorator('Pregnancies', {
                    rules: [{
                      required: true, message: 'Please input the number of pregnancies!',
                    }],
                    initialValue: '2',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Glucose"
                >
                  {getFieldDecorator('Glucose', {
                    rules: [{
                      required: true, message: 'Please input the Glucose level!',
                    }],
                    initialValue: '116',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Blood Pressure"
                >
                  {getFieldDecorator('BloodPressure', {
                    rules: [{
                      required: true, message: 'Please input the Blood Pressure!',
                    }],
                    initialValue: '74',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Skin Thickness"
                >
                  {getFieldDecorator('SkinThickness', {
                    rules: [{
                      required: true, message: 'Please input the Skin Thickness!',
                    }],
                    initialValue: '0',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Insulin"
                >
                  {getFieldDecorator('Insulin', {
                    rules: [{
                      required: true, message: 'Please input the Insulin!',
                    }],
                    initialValue: '0',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="BMI"
                >
                  {getFieldDecorator('BMI', {
                    rules: [{
                      required: true, message: 'Please input the BMI!',
                    }],
                    initialValue: '25.6',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Diabetes Pedigree Function"
                >
                  {getFieldDecorator('DiabetesPedigreeFunction', {
                    rules: [{
                      required: true, message: 'Please input the Diabetes Pedigree Function!',
                    }],
                    initialValue: '0.200',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Age"
                >
                  {getFieldDecorator('Age', {
                    rules: [{
                      required: true, message: 'Please input the Age!',
                    }],
                    initialValue: '30',
                  })(
                    <Input />
                  )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit">Predict</Button>
                </FormItem>
              </Form>
            </Col>
            <Col span={6} offset={3}>
              <Card title="Prediction Result" bordered={false} loading={this.state.loading}>
              {cardContent}
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    );
  }
}

export default (Form.create()(DiabetesForm));



// WEBPACK FOOTER //
// ./src/models/diabetes/predict/index.js